/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://Microlab.com/product/material-dashboard-react
* Copyright 2023 Microlab Team (https://Microlab.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
function Footer() {
  return null;
}

export default Footer;
